<div class="m-subheader">
  <div class="mr-auto">
    <h3 class="m-subheader__title">
      {{ 'sales.statistics.employees' | transloco }}
    </h3>
    <span></span>
    <hx-date-range-select [onlyPastDates]="true" class="date-align" [(ngModel)]="params.date" (selectChange)="applyFilters()"></hx-date-range-select>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'sales.statistics.store' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>
          </div>
          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30 block-table-scroll">
            <table class="m-datatable__table" *ngIf="sales.length && !isloading.sales">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.employee' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.store' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.total' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.profit' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.receipts' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.average-receipt' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let item of sales"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                <td class="m-datatable__cell">
                  <a *ngIf="item.paymentUserFullname" [title]="item.paymentUserFullname" [routerLink]="['../sales/employee']" [queryParams]="{dateFrom: params.date?.from, dateTo: params.date?.to, paymentUserId: item.paymentUserId, paymentUserFullname: item.paymentUserFullname }">
                    {{ item.paymentUserFullname }}
                  </a>
                </td>
                <td class="m-datatable__cell min-width-100">
                  {{ item.storeTitle | uiLabel }}
                </td>
                <td class="m-datatable__cell min-width-100">
                  {{ (item.total - item.coinSum) | fixed:2 | moneyFormat | uiCurrency: item.currency }}
                </td>
                <td class="m-datatable__cell min-width-100">
                  {{ ((item.total - item.coinSum) - item.costPriceSum) | fixed:2 | moneyFormat | uiCurrency: item.currency }}
                </td>
                <td class="m-datatable__cell min-width-100">
                  {{ item.orderCount }}
                </td>
                <td class="m-datatable__cell min-width-100">
                  {{ item.averageReceipt | fixed:2 | moneyFormat | uiCurrency: item.currency }}
                </td>
              </tr>
              </tbody>
            </table>

            <hx-loader [length]="sales.length" [isLoading]="isloading.sales"></hx-loader>

            <br/>
            <br/>

            <div class="m--align-center" *ngIf="sales.length && !isloading.sales && pagination.allItemCount > 0">
              <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                              [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
